"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUDIT_ANSWER_FRAGMENT = void 0;
var client_1 = require("@apollo/client");
exports.AUDIT_ANSWER_FRAGMENT = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment AuditAnswer on AuditAnswer {\n    id\n    question\n    answeredYes\n    questionId\n    image {\n      id\n      url\n      saved\n    }\n  }\n"], ["\n  fragment AuditAnswer on AuditAnswer {\n    id\n    question\n    answeredYes\n    questionId\n    image {\n      id\n      url\n      saved\n    }\n  }\n"])));
var templateObject_1;
